import * as api from '../connectivity/api.semesters';
import { call, put } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import * as types from '../constants/actionTypes';
import { showLoading, hideLoading } from 'react-redux-loading-bar';


export function* doRequestSemesters(action) {

    yield put(showLoading());
    try {
        yield put({
            type: types.REQUEST__STARTED,
            payload: {
                requestFrom: 'semesters.doRequestSemesters'
            }
        });

        let semesters = yield call(api.fetchSemesters);

        yield put({
            type: types.SEMESTERS__REQUESTED__SUCCEEDED,
            payload: { semesters }
        });
    } catch (e) {

        yield put({
            type: types.SEMESTERS__REQUESTED__FAILED,
            message: e.message
        });

    }
    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'semesters.doRequestSemesters'
        }
    });
    yield put(hideLoading());


}

export function* doRequestSemestersSucceeded(action) {
    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'semesters.doRequestSemesters'
        }
    });
}

export function* doRequestSemestersFailed(action) {
    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'semesters.doRequestSemesters'
        }
    });
}

export function* watchRequestSemesters() {
    yield* takeLatest(types.SEMESTERS__REQUESTED, doRequestSemesters);
}

export function* watchRequestSemestersSucceeded() {
    yield* takeLatest(types.SEMESTERS__REQUESTED__SUCCEEDED, doRequestSemestersSucceeded);
}

export function* watchRequestSemestersFailed() {
    yield* takeLatest(types.SEMESTERS__REQUESTED__FAILED, doRequestSemestersFailed);
}


/** WEBPACK FOOTER **
 ** ./src/sagas/semesters.saga.js
 **/